import { app } from '../../../../../../app';
import { Controller } from './bulk-verification-csv.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryBulkVerificationCsv', {
    bindings: {
        connectionDetails: '<',
        companyId: '<',
        directoryId: '<',
    },
    controller: Controller,
    templateUrl: require('./bulk-verification-csv.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification-csv/bulk-verification-csv.component.js